export default __webpack_public_path__ + "static/media/logo.72fcf2b7.webp";